import {
  CreateResourceIdempotencyToken,
  EditableFormIdempotencyToken,
  type FeatureRegistry,
  FlowSubmissionIdempotencyToken,
  ToggleIdempotencyToken,
  UpdateResourceIdempotencyToken,
  ValidationIdempotencyToken,
  ResendActionIdempotencyToken,
} from '@betterment/graphql';

export const featureRegistry: FeatureRegistry = {
  advised401kCustodialFeeds: {
    UpdatePlanFeedConsent: { idempotencyToken: ToggleIdempotencyToken },
  },
  billingPlans: {
    UpdateBillingPlanPaymentTypes: { idempotencyToken: ToggleIdempotencyToken },
    UpdateFirmDefaultBillingPlan: { idempotencyToken: ToggleIdempotencyToken },
    UpsertBillingPlan: { idempotencyToken: FlowSubmissionIdempotencyToken },
  },
  clientEnvelope: {
    UpdateClientEnvelopeBeneficiaries: { idempotencyToken: EditableFormIdempotencyToken },
    ValidateSolo401kPlanForm: { idempotencyToken: ValidationIdempotencyToken },
    DismissClientActivityCsvExport: { idempotencyToken: EditableFormIdempotencyToken },
    CreateClientActivityCsvExport: { idempotencyToken: EditableFormIdempotencyToken },
  },
  firmIntegrations: {
    UpdateFirmIntegrationSubscriptionStatus: { idempotencyToken: ToggleIdempotencyToken },
  },
  fourOhOneKDashboard: {
    CreateReport: { idempotencyToken: FlowSubmissionIdempotencyToken },
  },
  solo401k: {
    CreateDraftSolo401kConversionIntent: { idempotencyToken: FlowSubmissionIdempotencyToken },
    CreateDraft401kOnlyAdvisorSolo401kConversionIntent: { idempotencyToken: FlowSubmissionIdempotencyToken },
    UpdateSolo401kConversionIntentFundsType: { idempotencyToken: EditableFormIdempotencyToken },
    UpdateSolo401kConversionIntentContributions: { idempotencyToken: EditableFormIdempotencyToken },
    PublishSolo401kConversionIntent: { idempotencyToken: FlowSubmissionIdempotencyToken },
    ValidateSolo401kConversionIntent: { idempotencyToken: FlowSubmissionIdempotencyToken },
  },
  solo401kEnvelopes: {
    UpdateClientEnvelopeBeneficiaries: { idempotencyToken: EditableFormIdempotencyToken },
  },
  advisorGoalCreationFlow: {
    ValidateSolo401kPlanForm: { idempotencyToken: ValidationIdempotencyToken },
  },
  tradePreview: {
    CreateTradePreview: { idempotencyToken: ValidationIdempotencyToken },
  },
  securityOrder: {
    CreateFinancialSecurityOrder: { idempotencyToken: CreateResourceIdempotencyToken },
    CreateFinancialSecuritySellOrderTaxImpactPreview: { idempotencyToken: ValidationIdempotencyToken },
    ValidateFinancialSecurityOrderRequest: { idempotencyToken: ValidationIdempotencyToken },
  },
  onDemandBilling: {
    CreateBulkFeeIntent: { idempotencyToken: CreateResourceIdempotencyToken },
    CreateFirmBillableAccountsCsvExport: { idempotencyToken: ResendActionIdempotencyToken },
    DismissFirmBillableAccountsCsvExport: { idempotencyToken: UpdateResourceIdempotencyToken },
  },
  clientRequestForProposalInfo: {
    SubmitClientRequestForProposalInfo: { idempotencyToken: CreateResourceIdempotencyToken },
  },
  custom_fund_lineup: {
    UpdateQdiaFundLineup: { idempotencyToken: FlowSubmissionIdempotencyToken },
  },
  secLending: {
    SendClientSecuritiesLendingInvitation: { idempotencyToken: ResendActionIdempotencyToken },
  },
};
